<template>
    <div>
        <Table :no-data-text="$t('common.noData')" :columns="columns" :data="tableInstanceListData" style="width: 100.1%;"></Table>
         <!-- :page-size-opts="[2,4,6,8]" -->
        <Page :current="current" :total="dataTotal" show-sizer :page-size="pageSize" @on-change="changePage" @on-page-size-change="changeSize" :transfer="true"></Page>
    </div>
</template>
<script>
    var tableInstanceListVue = {};
    export default {
        name: 'TableInstanceList',
        data () {
            return {
                current:1,
                dataTotal:0,
                pageSize:10,
                environmentKey:'',
                startDate:'',
                columns: [
                    {
                        title: this.$t('instance_list.environment'),
                        key: 'environment'
                    },
                    {
                        title: this.$t('instance_list.instanceName'),
                        key: 'instanceName'
                    },
                    {
                        title: this.$t('instance_list.usageDetail'),
                        key: 'detailPurpose'
                    },
                    {
                        title: this.$t('instance_list.availableZone'),
                        key: 'availabilityZone'
                    },
                    {
                        title: this.$t('instance_list.privateIP'),
                        key: 'privateIp'
                    },
                    {
                        title: this.$t('instance_list.CPUNumber'),
                        key: 'cpu'
                    },
                    {
                        title: this.$t('instance_list.mem'),
                        key: 'memory'
                    },
                    {
                        title: this.$t('instance_list.disk'),
                        key: 'disk'
                    },
                    {
                        title: this.$t('instance_list.project'),
                        key: 'project'
                    },
                    {
                        title: this.$t('instance_list.business'),
                        key: 'businessName'
                    },
                    {
                        title: this.$t('instance_list.owner1'),
                        key: 'owner1'
                    },
                    {
                        title: this.$t('instance_list.owner2'),
                        key: 'owner2'
                    },
                    {
                        title: this.$t('instance_list.os'),
                        key: 'operatingSystem'
                    },
                    {
                        title: this.$t('instance_list.env'),
                        key: 'env'
                    },
                    {
                        title: this.$t('instance_list.billingType'),
                        key: 'tag'
                    }
                ],
                tableInstanceListData:[]
            }
        },
        beforeCreate: function() {
            tableInstanceListVue = this
        },
        mounted: function(){
            tableInstanceListVue.getInstanceListData();
        },
        methods:{
            showAll: function(){
                tableInstanceListVue.getInstanceListData();
            },
            // 分页显示数据
            /****************************************************/
            getInstanceListData:function() {
                eventBus.$on('environmentKeySearchID',function(environmentKey){
                    tableInstanceListVue.environmentKey=environmentKey;
                })
                eventBus.$on('startDateSearchID',function(startDate){
                    tableInstanceListVue.startDate=startDate;
                })
                this.$api.swireOpsInstance.pageSwireOpsInstance({
                    "startDate": tableInstanceListVue.startDate,
                    "environment": tableInstanceListVue.environmentKey,
                    "pageNum": this.current,
                    "pageSize": this.pageSize
                })
                .then(res => {
                    this.tableInstanceListData = res.data.records;
                    // 当前页
                    this.current = res.data.current;
                    // 总条数
                    this.dataTotal = res.data.total;
                });
            },
            changePage: function(current){
                this.current=current;
                tableInstanceListVue.getInstanceListData();
            },
            changeSize: function(pageSize){
                this.pageSize=pageSize;
                tableInstanceListVue.getInstanceListData();
            },
            // 销毁
            beforeDestroy: function(){
                eventBus.$off('environmentKeySearchID');
                eventBus.$off('startDateSearchID');
            }
        }
    }
</script>
<style scoped>
    .ivu-page
    {
        margin-top: 10px !important;
        margin-bottom: 30px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/instance_lists/instance_list/TableInstanceList.vue